export default {
  message: {
    hello: '¡Ola mundo!'
  },
  createAccount: {
    signinTitle: 'Crea tu cuenta Moip, es gratis!'
  }
}



// WEBPACK FOOTER //
// ./src/language/es.js